import type { ReactNode } from 'react';

export const symbol_headphones_battery: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M190-240h-40q-28.87 0-49.44-20.56Q80-281.13 80-310v-170q0-100 70-170t170-70q100 0 170 70t70 170v170q0 28.87-20.56 49.44Q518.88-240 490-240h-40q-12.75 0-21.37-8.63Q420-257.25 420-270v-120q0-12.75 8.63-21.38Q437.25-420 450-420h70v-60q0-83.33-58.26-141.67Q403.47-680 320.24-680 237-680 178.5-621.67 120-563.33 120-480v60h70q12.75 0 21.38 8.62Q220-402.75 220-390v120q0 12.75-8.62 21.37Q202.75-240 190-240Zm547-447v-18q0-6 4.5-10.5T752-720h30q6 0 10.5 4.5T797-705v18h50q14.03 0 23.51 9.49Q880-668.03 880-654v381q0 14.02-9.49 23.51Q861.03-240 847-240H692q-14.03 0-23.51-9.49Q659-258.98 659-273v-381q0-14.03 9.49-23.51Q677.97-687 692-687h45Zm-18 387h101-101Zm0 0h101v-327H719v327Z"
		/>
	</svg>
);
